import styled from "@emotion/styled";
import React from "react";
import { RafflePreviousWinner } from "../Raffle.types";

type Props = {
  previousWinners: RafflePreviousWinner[];
};

export default function RafflePreviousWinnersCard(props: Props) {
  return (
    <Root>
      {props.previousWinners.map((winner, index) => (
        <WinnerItem key={index}>
          <Avatar src={winner.avatar} />
          <WinnerDetails>
            <WinnerName>{winner.name}</WinnerName>
            <WinnerPrize>{winner.prize}</WinnerPrize>
          </WinnerDetails>
        </WinnerItem>
      ))}
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 8px;
`;

const WinnerItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const WinnerDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const WinnerName = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #333;
`;

const WinnerPrize = styled.div`
  font-size: 14px;
  color: #666;
`;

const Avatar = styled.div<{ src: string | null }>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-image: url(${(props) => props.src ?? "/assets/avatar.svg"});
  background-size: cover;
  background-position: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
